
import VueRouter from 'vue-router'
import Auth from './Auth'
import Contact from './Contact'
import Labels from './Labels'
import UploadListing from './UploadListing'
import EANManager from './EANManager'
import UploadSettings from './UploadSettings'
import ListingSize from './ListingSize'
import EbayInvoice from './EbayInvoice'

const router = new VueRouter({

  routes: [
    {
      path: '',
      component: Auth,
      name: "Login"
    },
    {
      path: '/ebayinvoice',
      component: EbayInvoice,
      name: "Ebay Rechnungen",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/labels',
      component: Labels,
      name: "Labels",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uploadListing',
      component: UploadListing,
      name: "Angebote hochladen",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ean',
      component: EANManager,
      name: "EAN Einstellungen",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/listingsize',
      component: ListingSize,
      name: "Angebots-Größen",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/uploadsettings',
      component: UploadSettings,
      name: "Upload Einstellungen",
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/contact',
      component: Contact,
      name: "Kontakt"
    }
  ],
  // mode: 'history'
})

// router.beforeEach((to, from, next) => {
//   debugger//eslint-disable-line no-debugger
//   if (to.matched.some((record) => record.meta.requiresAuth)){
//     let jwt = localStorage.getItem("authToken")
//     if(!jwt) next("/")
//
//     Api.auth.verify({authToken: jwt}
//         .then(res => {
//           debugger//eslint-disable-line no-debugger
//           if(res.code === 200) next();
//           else next('/')
//         }))
//         .catch(() => {
//           debugger//eslint-disable-line no-debugger
//           next('/')
//         })
//   } else {
//     //route doesn't need auth
//     next();
//   }
// });

export default router